import * as actionTypes from './actionTypes';
import { HttpError } from '../../config/Axios/axios-instance';
import {
  CreditPackage,
  CreditPackageListType,
} from '../../domain/CreditPackage';

export const fetchCreditPackagesStart = () => ({
  type: actionTypes.FETCH_CREDIT_PACKAGES_START,
});

export const fetchCreditPackagesSuccess = (
  creditPackagesList: CreditPackageListType,
) => ({
  type: actionTypes.FETCH_CREDIT_PACKAGES_SUCCESS,
  creditPackagesList,
});

export const fetchCreditPackagesFail = (creditPackagesError: HttpError) => ({
  type: actionTypes.FETCH_CREDIT_PACKAGES_FAIL,
  creditPackagesError,
});

export const fetchCreditPackageStart = () => ({
  type: actionTypes.FETCH_CREDIT_PACKAGE_START,
});

export const fetchCreditPackageSuccess = (creditPackage: CreditPackage) => ({
  type: actionTypes.FETCH_CREDIT_PACKAGE_SUCCESS,
  creditPackage,
});

export const fetchCreditPackageFail = (creditPackageError: HttpError) => ({
  type: actionTypes.FETCH_CREDIT_PACKAGE_FAIL,
  creditPackageError,
});

export const fetchCreditPackageOptionsFail = (
  creditPackageOptionsError: HttpError,
) => ({
  type: actionTypes.FETCH_CREDIT_PACKAGE_FAIL,
  creditPackageOptionsError,
});

export const createCreditPackageStart = () => ({
  type: actionTypes.CREATE_CREDIT_PACKAGE_START,
});

export const createCreditPackageSuccess = (
  createdCreditPackage: CreditPackage,
) => ({
  type: actionTypes.CREATE_CREDIT_PACKAGE_SUCCESS,
  createdCreditPackage,
});

export const createCreditPackageFail = (
  creditPackageCreateError: HttpError,
) => ({
  type: actionTypes.CREATE_CREDIT_PACKAGE_FAIL,
  creditPackageCreateError,
});

export const updateCreditPackageStart = () => ({
  type: actionTypes.UPDATE_CREDIT_PACKAGE_START,
});

export const updateCreditPackageSuccess = () => ({
  type: actionTypes.UPDATE_CREDIT_PACKAGE_SUCCESS,
});

export const updateCreditPackageFail = (
  creditPackageUpdateError: HttpError,
) => ({
  type: actionTypes.UPDATE_CREDIT_PACKAGE_FAIL,
  creditPackageUpdateError,
});

export const deleteCreditPackageStart = () => ({
  type: actionTypes.DELETE_CREDIT_PACKAGE_START,
});

export const deleteCreditPackageSuccess = () => ({
  type: actionTypes.DELETE_CREDIT_PACKAGE_SUCCESS,
});

export const deleteCreditPackageFail = (
  creditPackageDeleteError: HttpError,
) => ({
  type: actionTypes.DELETE_CREDIT_PACKAGE_FAIL,
  creditPackageDeleteError,
});

export const resetCreatedOrEditedCreditPackage = () => ({
  type: actionTypes.RESET_CREATED_OR_EDITED_CREDIT_PACKAGE,
});

export const resetCreditPackagesStore = () => ({
  type: actionTypes.RESET_CREDIT_PACKAGES_STORE,
});
